module.exports = __webpack_public_path__ + "img/9788936433697.b2b33469.jpg";